<template>
  <employee-view-content
    :employee-id="Number($route.params.Id)"
    :user="$store.getters.user"
  />
</template>

<script>
import EmployeeViewContent from './EmployeeViewContent.vue'
export default {
  components: {
    'employee-view-content': EmployeeViewContent
  }
}
</script>
